import { PropsWithChildren } from "react";
import { Box, Stack } from "@mui-wrapper";
import FaroSphereLogo from "@assets/icons/faro-sphere-xg-logo-color.svg?react";
import { useMediaQueries } from "@hooks/use-media-queries";
import { NavLink } from "react-router-dom";
import { resetLoginState } from "@store/login/login-slice";
import { useAppDispatch } from "@store/store-helper";

/**
 * Unified Login Mask (ULM) container
 */
export function UlmContainer({ children }: PropsWithChildren): JSX.Element {
  const { isSmallHeightScreen } = useMediaQueries();
  const dispatch = useAppDispatch();

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 440,
          minWidth: 200,
          margin: "10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Stack
          direction="column"
          sx={{
            alignItems: "center",
            width: "inherit",
            marginTop: isSmallHeightScreen ? "0" : "80px",
          }}
        >
          <Box
            component={NavLink}
            to={"/login"}
            onClick={() => {
              dispatch(resetLoginState());
            }}
            sx={(theme) =>
              // The wordmark is the logo's `st0` class, the brand navy, which all but vanishes on
              // the dark background. Only the wordmark follows the scheme; the sphere keeps its
              // brand gradient, and light mode keeps the navy.
              theme.applyStyles("dark", {
                "& .st0": { fill: theme.vars.palette.text.primary },
              })
            }
          >
            <FaroSphereLogo
              style={{
                width: "150px",
                minHeight: "80px",
              }}
            />
          </Box>

          {children}
        </Stack>
      </Box>
    </Box>
  );
}
